import { getSyncStatus } from '@/api/integrations';
import { useApiQuery } from '@/hooks/api';
import { REFERENCE_STALE_TIME } from '@/hooks/api/defaults';
import { queryKeys } from '@/shared/lib/queryKeys';

type SyncStatus = {
  awaiting_initial_sync: boolean;
  needs_reauth: boolean;
};

export function useSyncStatusQuery(options?: { enabled?: boolean }) {
  const { enabled = true } = options ?? {};

  return useApiQuery<SyncStatus>({
    queryKey: queryKeys.integrations.syncStatus(),
    queryFn: () => getSyncStatus(),
    enabled,
    staleTime: REFERENCE_STALE_TIME,
  });
}
